export const SET_PLAN_SPONSOR_SLUG =
    'planSponsorSlugActionTypes/SET_PLAN_SPONSOR_SLUG';
export interface SetPlanSponsorSlugAction {
    type: typeof SET_PLAN_SPONSOR_SLUG;
    id: string;
}

export type PlanSponsorSlugAction = SetPlanSponsorSlugAction;
